// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "calendar__legNumber-RF-95";
var _5 = "calendar__title__cities-3mqEx";
var _6 = "calendar__diagram-2YmUN";
var _7 = "weekCalendar__slider-1nsyt";
var _8 = "weekCalendar__price-2VKMK";
var _9 = "weekcalendar__date-LuMZq";
var _a = "weekCalendar__day_selected-3_qrd";
var _b = "weekCalendar__day_best-3ue0Y";
var _c = "weekCalendar__day-ud59J";
var _d = "weekCalendar__date__info-1ijTl";
var _e = "sortings__title-obPxy";
var _f = "sortings__flightType-3uu5U";
var _10 = "sortings__currentSorting-kwHYW";
var _11 = "sortings__flightType__active-N3qmv";
var _12 = "results-33xJJ";
var _13 = "header__stepbar-36rUq";
var _14 = "flightList__leg-iSUoz";
var _15 = "flightList__controls__wrapper-7f6iX";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "calendar__legNumber", _5 as "calendar__title__cities", _6 as "calendar__diagram", _7 as "weekCalendar__slider", _8 as "weekCalendar__price", _9 as "weekcalendar__date", _a as "weekCalendar__day_selected", _b as "weekCalendar__day_best", _c as "weekCalendar__day", _d as "weekCalendar__date__info", _e as "sortings__title", _f as "sortings__flightType", _10 as "sortings__currentSorting", _11 as "sortings__flightType__active", _12 as "results", _13 as "header__stepbar", _14 as "flightList__leg", _15 as "flightList__controls__wrapper" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "calendar__legNumber": _4, "calendar__title__cities": _5, "calendar__diagram": _6, "weekCalendar__slider": _7, "weekCalendar__price": _8, "weekcalendar__date": _9, "weekCalendar__day_selected": _a, "weekCalendar__day_best": _b, "weekCalendar__day": _c, "weekCalendar__date__info": _d, "sortings__title": _e, "sortings__flightType": _f, "sortings__currentSorting": _10, "sortings__flightType__active": _11, "results": _12, "header__stepbar": _13, "flightList__leg": _14, "flightList__controls__wrapper": _15 }
